import { Grid, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';
import RegularButton from 'components/CustomButtons/Button'
import { useForm } from 'hooks/useForm';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { convertToMapById } from "helpers/convertToMap";
import {
    fetchStationUnits,
    createNewAssignedCoverage,
    editAssignedCoverage
} from 'redux/actions/coveragesAssign/coveragesAssignActions'
import { fetchCoverages } from "redux/actions/coverages/coveragesActions";

export const FormAssignEdit = (props) => {
    const { handleClose } = props
    const { stationsList } = useSelector(state => state.companies);
    const { stationUnits, addMode, assignedCoverageSelected } = useSelector(state => state.coveragesAssign)
    const { coverages } = useSelector(state => state.coverages)
    const { inputValues, handleInputOnChange, handleNewValues, runValidates, fieldErrors } = useForm({
        id_station: '',
        id_polygon: '',
        id_unit: '',
        status: 'ACTIVE'
    }, {
        id_station: { required: true },
        id_polygon: { required: true },
        id_unit: { required: true }
    })
    const { id_station, id_polygon, id_unit, status } = inputValues
    const [mapCoverages, setMapCoverages] = useState([]);
    const [mapStationUnits, setMapStationUnits] = useState([])

    const dispatch = useDispatch()

    const getCoverages = useCallback(
        stationID => {
            dispatch(fetchCoverages(stationID));
        }, []);

    useEffect(() => {
        setMapCoverages(convertToMapById(coverages.map(obj => ({ ...obj, label: obj.name, value: obj.id }))));
    }, [coverages]);

    useEffect(() => {
        setMapStationUnits(convertToMapById(stationUnits.map(obj => ({ ...obj, label: obj.number, value: obj.id }))));

        if (!addMode) {
            handleNewValues({
                ...inputValues,
                id_unit: stationUnits.find(obj => obj.id == assignedCoverageSelected?.id_unit)?.id
            })
        }
    }, [stationUnits]);

    useEffect(() => {
        if (!id_station) return

        getCoverages(id_station);
        dispatch(fetchStationUnits(id_station))
    }, [id_station]);

    useEffect(() => {
        if (!addMode) {
            handleNewValues({
                ...inputValues,
                id_station: assignedCoverageSelected?.id_station,
                id_polygon: assignedCoverageSelected?.id_polygon,
                id_unit: assignedCoverageSelected?.id_unit,
                status: assignedCoverageSelected?.status
            })
        }
    }, [assignedCoverageSelected])

    const handleSubmit = useCallback((e) => {
        e.preventDefault()
        if (runValidates()) return

        const form = {
            ...inputValues,
            id_station
        }

        if (addMode) {
            dispatch(createNewAssignedCoverage(form, handleClose))
        } else {
            dispatch(editAssignedCoverage(assignedCoverageSelected.id, form, handleClose))
        }
    }, [inputValues, id_station, addMode, assignedCoverageSelected, runValidates, dispatch, handleClose])

    return (
        <>
            <FormControl fullWidth onSubmit={handleSubmit}>
                <Grid container spacing={1} style={{ paddingRight: 0 }}>
                    {!addMode && (
                        <Grid item xs={12} sm={12}>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="outlined-age-native-simple">Estatus *</InputLabel>
                                <Select
                                    value={status}
                                    name='status'
                                    onChange={handleInputOnChange}
                                    label="Estatus"
                                >
                                    <MenuItem value='ACTIVE'>Activo</MenuItem>
                                    <MenuItem value='INACTIVE'>Inactivo</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    <Grid item xs={12} sm={12}>
                        <FormControl variant="outlined" fullWidth error={!!fieldErrors.id_station}>
                            <InputLabel htmlFor="outlined-age-native-simple">Planta *</InputLabel>
                            <Select
                                value={id_station}
                                name='id_station'
                                onChange={handleInputOnChange}
                                label="Planta"
                            >
                                <MenuItem value=''>Seleccione una planta</MenuItem>
                                {
                                    stationsList.map(({ label, value }) => (
                                        <MenuItem key={value} value={value}>{label}</MenuItem>
                                    ))
                                }
                            </Select>
                            <FormHelperText style={{ color: 'red' }}>{fieldErrors.id_station || ""}</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl variant="outlined" fullWidth error={!!fieldErrors.id_polygon}>
                            <InputLabel htmlFor="outlined-age-native-simple">Cobertura *</InputLabel>
                            <Select
                                value={id_polygon}
                                name='id_polygon'
                                onChange={handleInputOnChange}
                                label="Cobertura"
                                disabled={!id_station}
                            >
                                <MenuItem value=''>Seleccione una cobertura</MenuItem>
                                {
                                    mapCoverages.map(({ label, value }) => (
                                        <MenuItem key={value} value={value}>{label}</MenuItem>
                                    ))
                                }
                            </Select>
                            <FormHelperText style={{ color: 'red' }}>{fieldErrors.id_polygon || ""}</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl variant="outlined" fullWidth error={!!fieldErrors.id_unit}>
                            <InputLabel htmlFor="outlined-age-native-simple">Unidad *</InputLabel>
                            <Select
                                value={id_unit}
                                name='id_unit'
                                onChange={handleInputOnChange}
                                label="Unidad"
                                disabled={!id_polygon}
                            >
                                <MenuItem value=''>Seleccione una unidad</MenuItem>
                                {
                                    mapStationUnits.map(({ label, value }) => (
                                        <MenuItem key={value} value={value}>{label}</MenuItem>
                                    ))
                                }
                            </Select>
                            <FormHelperText style={{ color: 'red' }}>{fieldErrors.id_unit || ""}</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <RegularButton size="small" color="danger" onClick={handleClose}>Cancelar</RegularButton>
                        <RegularButton
                            color="info"
                            size="small"
                            onClick={handleSubmit}
                        >
                            {addMode ? 'Crear cobertura' : 'Guardar'}
                        </RegularButton>
                    </Grid>
                </Grid>
            </FormControl>
        </>
    )
}
